import FieldConfig from "../../../proto/field-config"
import FieldProgress from "../../../generic/progress/progress"
import Task from "../../../../model2/task/task"
import FieldTaskProgressItems_TableCell from "./render/table/table-cell"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldTaskProgressItems extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Progress items"
        this.label      = _.get(config, 'label', 'Progress items')
        this.icon       = 'i5-progress'

        this.renderComponents.tableCell = FieldTaskProgressItems_TableCell
    }

    canEdit(model:Task):boolean {
        return false
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    return listItem.tree.numChildren
                },
                (listItem: ItemModelV2) => {
                    return !_.isNil(listItem.task.progressSubItems?.done) ? listItem.task.progressSubItems?.done : 0
                },
                (listItem: ItemModelV2) => {
                    return !_.isNil(listItem.task.progressSubItems?.total) ? listItem.task.progressSubItems?.total : 0
                }
            ],
            directions  : [sort, sort, sort]
        }
    }
}
